module.exports = __webpack_public_path__ + "img/octopus_playing_in_reflecting_pool.90d99a4b.jpg";